// No-op messaging functions for web platform
export const getMessaging = () => null

/* eslint-disable @typescript-eslint/no-unused-vars */
export const setBackgroundMessageHandler = (handler: () => Promise<void>) => {
  // No-op for web
  console.log('setBackgroundMessageHandler for web')
  return Promise.resolve()
}

export const getToken = async () => {
  // No-op for web
  return null
}

export const requestPermission = async () => {
  // No-op for web, return true to simulate permission granted
  return true
}

/* eslint-disable @typescript-eslint/no-unused-vars */
export const onNotificationOpenedApp = (
  listener: (remoteMessage: any) => void,
) => {
  // No-op for web
  console.log('onNotificationOpenedApp for web - no-op')
}

export const onMessage = (listener: (remoteMessage: any) => void) => {
  // No-op for web
  console.log('onMessage for web - no-op')
}

export const getInitialNotification = (): Promise<{ data?: any } | null> => {
  // No-op for web
  console.log('getInitialNotification for web - no-op')
  return Promise.resolve(null)
}
